const SEARCH_TYPE_ORDER = [
  "tablecloths",
  "napkins",
  "chargers_placemats",
  "runners",
  "accessories",
  "spandex",
  "other",
];

const SEARCH_TYPE_RANK = SEARCH_TYPE_ORDER.reduce((acc, type, index) => {
  acc[type] = index;
  return acc;
}, {});

const getProductSearchType = (product) => {
  const name = (product?.name || "").toLowerCase();
  const slug = (product?.slug || "").toLowerCase();
  const sizes = [
    ...(Array.isArray(product?.sizes) ? product.sizes : []),
    ...(Array.isArray(product?.size) ? product.size : []),
    ...(Array.isArray(product?.product_size) ? product.product_size : []),
  ]
    .join(" ")
    .toLowerCase();

  const haystack = `${name} ${slug} ${sizes}`;

  const hasAny = (keywords) =>
    keywords.some((keyword) => haystack.includes(keyword));

  if (hasAny(["spandex", "stretch"])) return "spandex";

  if (
    hasAny([
      "napkin ring",
      "ring",
      "vase",
      "vases",
      "pillow",
      "pillows",
      "candle holder",
      "candle holders",
      "accessory",
      "accessories",
    ])
  ) {
    return "accessories";
  }

  if (hasAny(["table runner", "runner"])) return "runners";

  if (hasAny(["charger", "placemat", "placemats"])) return "chargers_placemats";

  if (
    hasAny([
      "table linen",
      "tablecloth",
      "table cloth",
      "overlay",
      "90” x",
      "108” x",
      "120” round",
      "132” round",
    ])
  ) {
    return "tablecloths";
  }

  if (hasAny(["napkin"])) return "napkins";

  return "other";
};

export const sortSearchResults = (products = []) => {
  return [...products].sort((a, b) => {
    const typeA = getProductSearchType(a);
    const typeB = getProductSearchType(b);
    const rankA = SEARCH_TYPE_RANK[typeA] ?? SEARCH_TYPE_RANK.other;
    const rankB = SEARCH_TYPE_RANK[typeB] ?? SEARCH_TYPE_RANK.other;

    if (rankA !== rankB) return rankA - rankB;

    return (a?.name || "").localeCompare(b?.name || "");
  });
};
